"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.conciergeUpdateWorkOrder = void 0;
const client_1 = require("@apollo/client");
exports.conciergeUpdateWorkOrder = (0, client_1.gql) `
  mutation conciergeUpdateWorkOrder($id: ID!, $input: WorkOrderUpdateInput!) {
    conciergeUpdateWorkOrder(id: $id, input: $input) {
      id
    }
  }
`;
//# sourceMappingURL=work-order.queries.graphql.js.map